import type { ReactNode } from "react"
import {
  useMemo,
  useState,
} from "react"

import { OverlayLoaderContext } from "./OverlayLoaderContext"
import { OverlayLoader } from "src/components/OverlayLoader"

type Props = {
  children?: ReactNode;
}

export function OverlayLoaderProvider(props: Props) {
  const [
    isVisible,
    setIsOverlayLoaderVisible,
  ] = useState(false)

  const value = useMemo(
    () => ({
      setIsOverlayLoaderVisible,
    }),
    [setIsOverlayLoaderVisible],
  )

  return (
    <OverlayLoaderContext.Provider value={value}>
      <OverlayLoader visible={isVisible} />
      {props.children}
    </OverlayLoaderContext.Provider>
  )
}
